export class Validator {
  private $el;
  private FIELD_INVALID_CLASS:string = 'form__field--invalid';
  constructor() {
  }


  /**
   * Valide field input
   * @param {HTMLInputElement} field to validate
   * @return {boolean} validation result
   */
  public validateField(field:HTMLInputElement) {
    var patt;

    // If field has pattern, use it to validate
    if(field.pattern) {
      patt = new RegExp(field.pattern, 'i');

      return patt.test(field.value);
    }

    // Else check for required and empty value
    if(field.required && field.value === '') {
      return false;
    }

    // If no pattern or required attributes are found, any valye goes
    return true;
  }

  /**
   * Get invalid class used for form inputs
   * @return {string} invalid class
   */
  public getFieldInvalidClass() {
    return this.FIELD_INVALID_CLASS;
  }
}
